<template>
  <div
    class="clearfix"
    style="display: inline-block;"
  >
    <button
      type="button"
      id="settings-engineers-add-group"
      class="btn btn--darkblue"
      @click="init()"
    >{{ $t('action.add') }}</button>

    <div
      class="reveal"
      ref="groupSettingAddModal"
      id="groupSettingAddModal"
      data-reveal
    >

      <div class="modal-container">
        <div>
          <label
            id="settings-engineers-add-group-label"
            class="confirm-header tender-font"
          >{{ $t('settings.addGroup') }}</label>
        </div>
        <div>
          <label
            id="settings-engineers-add-group-name"
            class="tender-font emphasis required-flag"
          >{{ $t('settings.groupName') }}</label>
          <input
            type="text"
            id="settings-engineers-add-group-name-value"
            :class="{'is-invalid-input':(apprErrHint && group.name.trim().length === 0)}"
            v-model="group.name"
            required
          >
        </div>
        <div>
          <label
            id="settings-engineers-add-group-description"
            class="tender-font  emphasis required-flag"
          >{{ $t('description') }}</label>
          <input
            type="text"
            id="settings-engineers-add-group-description-value"
            :class="{'is-invalid-input':(apprErrHint && group.note.trim().length === 0)}"
            v-model="group.note"
            required
          >
        </div>
      </div>
      <span
        class="form-error is-visible appr-error-message"
        v-if="apprErrHint"
      >
        {{ apprErrHint }}
      </span>

      <div class="row align-right nav_btn">
        <button
          type="button"
          class="btn btn--darkblue"
          @click="closeAddGroupModal()"
          aria-label="Close reveal"
        >{{ $t('action.cancel') }}</button>
        <button
          type="button"
          class="btn btn--orange"
          @click="addGroup()"
        >{{ $t('action.add') }}</button>
      </div>
    </div>

  </div>
</template>

<script>
import HttpStatus from 'http-status-codes'
import HTTP from '@/utils/http'

function getDefaultData () {
  return {
    apprErrHint: '',
    group: {
      name: '',
      note: '',
    },
  }
}

export default {
  name: 'AddGroup',

  data: getDefaultData,

  props: {
    allGroups: {
      type: Array,
    },
  },

  methods: {
    handleResponseAlert (err) {
      const response = err.response
      if (response.status >= HttpStatus.INTERNAL_SERVER_ERROR) {
        this.apprErrHint = this.$i18n.t('error.system')
      } else if (response.status >= HttpStatus.BAD_REQUEST) {
        this.apprErrHint = `${this.$i18n.t('error.checkInput')}`
      }
    },
    openAddLocationModal () {
      this.groupSettingAddModal.open()
    },
    closeAddGroupModal () {
      this.groupSettingAddModal.close()
    },
    reset (keep) {
      const def = getDefaultData()
      def[keep] = this[keep]
      Object.assign(this.$data, def)
    },

    async init () {
      this.reset()
      if (!this.groupSettingAddModal) {
        this.groupSettingAddModal = await new Foundation.Reveal($('#groupSettingAddModal'), {
          closeOnEsc: false,
          closeOnClick: false,
        })
      }
      await this.openAddLocationModal()
    },

    async addGroup () {
      const groupName = this.group.name.trim()
      if (!this.group || !groupName || !this.group.note.trim()) {
        this.apprErrHint = this.$i18n.t('error.checkInput')
        return
      }

      if (this.allGroups.some(item => item.name === groupName)) {
        this.apprErrHint = this.$i18n.t('settings.duplicateGroupName')
        return
      }
      try {
        const response = await HTTP.post('/roles', this.group)
        const newGroup = response.data.data || ''
        await this.closeAddGroupModal()
        if (newGroup) {
          this.navToDetail(newGroup.id)
        }
      } catch (err) {
        this.handleResponseError(err)
      }
    },

    navToDetail (id) {
      if (id) {
        this.$router.push({
          name: 'security-group-detail',
          params: {
            id,
          },
        })
      }
    },
  },
  destroy () {
    if (this.groupSettingAddModal) {
      this.groupSettingAddModal.destroy()
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/settings/style';
@import '~styles/popup';

#groupSettingAddModal {
  label {
    margin-top: 0;
  }
  input {
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
